import type { Map } from "./types";

const maps: Map[] = [
  {
    id: "map-groudon",
    name: "Theia Sky Ruins",
    image: "maps/map-groudon/map-groudon@4x.png",
    images: {
      "1": "maps/map-groudon/map-groudon@1x.png",
      "2": "maps/map-groudon/map-groudon@2x.png",
      "4": "maps/map-groudon/map-groudon@4x.png",
    },
    description: "Map with Groudon",
  },
  {
    id: "map-kyogre",
    name: "Theia Sky Ruins",
    image: "maps/map-kyogre/map-kyogre@4x.png",
    images: {
      "1": "maps/map-kyogre/map-kyogre@1x.png",
      "2": "maps/map-kyogre/map-kyogre@2x.png",
      "4": "maps/map-kyogre/map-kyogre@4x.png",
    },
    description: "Map with Kyogre",
  },
  {
    id: "map-rayquaza",
    name: "Theia Sky Ruins",
    image: "maps/map-rayquaza/map-rayquaza@4x.png",
    images: {
      "1": "maps/map-rayquaza/map-rayquaza@1x.png",
      "2": "maps/map-rayquaza/map-rayquaza@2x.png",
      "4": "maps/map-rayquaza/map-rayquaza@4x.png",
    },
    description: "Map with Rayquaza",
  },
];

export default maps;
